module.exports = __webpack_public_path__ + "static/img/irole.09d8f65.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/sy/irole.png
// module id = lh03
// module chunks = 7